<template>
  <div>
    <v-row dense>
      <v-col cols="12" sm="12" md="12" lg="12" xl="8">
        <v-card elevation="0" class="rounded-0 mb-0" :color="$vuetify.theme.dark ? '#162334' : '#e8f1f8'">
          <TradingChart></TradingChart>
        </v-card>
      </v-col> 
      <v-col cols="12" sm="12" md="12" lg="12" xl="4">
        <SymbolTable></SymbolTable>
      </v-col>  
    </v-row>
    <TradingMarketTable></TradingMarketTable>
  </div>
</template>

<script>
import SymbolTable from "@/components/TradeMaster/TradingMarketTab/SymbolTable.vue";
import TradingChart from "@/components/TradeMaster/TradingMarketTab/TradingChart.vue";
import TradingMarketTable from "@/components/TradeMaster/TradingMarketTab/TradingMarketTable.vue";
export default {
  components: {
    TradingMarketTable,
    TradingChart,
    SymbolTable,
  },
};
</script>
